<template>
  <wrapper>
    <main class="main-content-wrapper">
      <div class="item-card">
        <div class="row">
          <div class="col-md-2">
            <div class="item-label">Item Code</div>
            <div class="item-value">{{ this.$route.params.id }}</div>
          </div>
          <div class="col-md-1 text-center d-none d-md-block">
            <div style="width: 1px; height: 40px; background-color: #e0e0e0; margin: 0 auto;"></div>
          </div>
          <div class="col-md-6">
            <div class="item-label">Part Name</div>
            <div class="item-value">{{`${this.$route.query.itemGroup} - ${this.$route.query.itemName}`}}</div>
          </div>
          <div class="col-md-3 text-right mt-3 mt-md-0" v-if="modelList.length > 0">
            <button class="btn btn-primary btn-add-models" @click="openModalAddModel" v-if="addPartCompatiblity">
              <span style="font-size: 18px; margin-right: 5px;">+</span>
              Add Models
            </button>
          </div>
        </div>
      </div>

      <br />
      <div class="search-delete-container">
        <div class="search-wrapper">
          <div class="search-section">
            <div class="search-label">Search Model Name</div>
            <div class="search-input-wrapper">
              <i class="fas fa-search search-icon"></i>
              <input 
                type="text" 
                class="search-input" 
                v-model="searchModel" 
                placeholder="Search..."
                style="max-width: 500px;"
              >
              <span class="clear-icon" v-if="searchModel" @click="() => {searchModel = ''}">×</span>
            </div>
          </div>

          <button class="btn-delete-selected" @click="openConfirmDeleteModal()" v-if="selectedModels.length >0 && deletePartCompatiblity">
            <i class="fas fa-trash-alt"></i>
            Delete {{ selectedModels.length }} Selected
          </button>
        </div>
      </div>
      <!-- <div class="search-container"> -->
        <table class="table table-sm table-bordered table-striped table-responsive-sm">
          <thead>
            <tr>
              <th class="text-center" >
                <input type="checkbox" class="checkbox-custom" v-model="selectAll" @change="toggleSelectAll">
              </th>
              <th class="text-center">Model Name</th>
              <th class="text-center">Item Codes</th>
              <th class="text-center">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="loadingTable">
              <td colspan="4" class="text-center">
                <img src="~@/assets/images/load-button.gif" />
              </td>
            </tr>
            <tr v-if="modelList.length == 0 && !loadingTable" style="background-color: #FFFFFF;">
              <td colspan="4" style="text-align: center;" class="empty-state">
                <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 64 64" fill="none">
                  <path d="M0 32C0 14.3269 14.3269 0 32 0C49.6731 0 64 14.3269 64 32C64 49.6731 49.6731 64 32 64C14.3269 64 0 49.6731 0 32Z" fill="#EFF6FF"/>
                  <path d="M40.0001 22.6667C40.7074 22.6667 41.3856 22.9477 41.8857 23.4478C42.3858 23.9479 42.6668 24.6262 42.6668 25.3334V36.7014C42.6666 37.1167 42.7634 37.5262 42.9494 37.8974L44.3734 40.7334C44.4762 40.9374 44.5249 41.1644 44.5148 41.3926C44.5046 41.6208 44.4361 41.8425 44.3156 42.0366C44.1951 42.2307 44.0269 42.3905 43.8269 42.5009C43.6269 42.6112 43.4019 42.6683 43.1734 42.6667H20.8268C20.5984 42.6683 20.3734 42.6112 20.1734 42.5009C19.9734 42.3905 19.8051 42.2307 19.6846 42.0366C19.5642 41.8425 19.4956 41.6208 19.4854 41.3926C19.4753 41.1644 19.524 40.9374 19.6268 40.7334L21.0508 37.8974C21.2368 37.5262 21.3336 37.1167 21.3334 36.7014V25.3334C21.3334 24.6262 21.6144 23.9479 22.1145 23.4478C22.6146 22.9477 23.2929 22.6667 24.0001 22.6667H40.0001Z" stroke="#247FEC" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M42.7386 37.3159H21.2612" stroke="#247FEC" stroke-width="2.66667" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
                <div class="empty-title">No models yet</div>
                <div class="empty-subtitle" v-if="addPartCompatiblity">Get started by adding your first unit model</div>
                <button class="btn-add-models" @click="openModalAddModel" v-if="addPartCompatiblity">
                  <i class="fas fa-plus"></i>
                  Add Models
                </button>
              </td>
            </tr>
            <tr v-else v-for="model in filteredModelList" :key="model.itemCode">
              <td class="text-center">
                <input type="checkbox" class="checkbox-custom" :checked="selectedModels.find(item => item.itemCode == model.itemCode)" @click="toggleSelected(model)">
              </td>
              <td>{{ model.itemName }}</td>
              <td>
                <span v-for="code in model.itemCodes" :key="code" class="item-code-badge">
                  {{ code }}
                </span>
              </td>
              <td class="text-center">
                <button class="btn-delete" @click="openConfirmDeleteModal(model)" v-if="deletePartCompatiblity">
                  <i class="fas fa-trash-alt"></i>
                </button>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="total-models">
          Total Models: {{ modelList.length }}
        </div>
      <!-- </div> -->
    </main>
    <!-- /#page-content-wrapper -->
    <!-- Modal Section -->
     <ModalAddModel :dataPart="dataPart"/>

     <div class="modal fade" id="modalDeleteConfirmation" tabindex="-1" role="dialog" ref="deleteModal">
      <div class="modal-dialog modal-dialog-centered" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" @click="closeDeleteModelConfirm" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="warning-icon">
              <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
                <rect x="3" y="3" width="74" height="74" rx="37" stroke="#FDE5E7" stroke-width="6"/>
                <path d="M36 19.4286C36 17.535 37.567 16 39.5 16C41.433 16 43 17.535 43 19.4286V49.1429C43 51.0364 41.433 52.5714 39.5 52.5714C37.567 52.5714 36 51.0364 36 49.1429V19.4286Z" fill="#E7000B"/>
                <path d="M43 60.5714C43 62.465 41.433 64 39.5 64C37.567 64 36 62.465 36 60.5714C36 58.6779 37.567 57.1429 39.5 57.1429C41.433 57.1429 43 58.6779 43 60.5714Z" fill="#E7000B"/>
              </svg>
            </div>
            <h5 class="modal-title">Are you sure?</h5>
            <p class="warning-text">
               <span class="item-name">{{ deleteModelWarningMsg }}</span> will permanently removed from the list.
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-secondary" @click="closeDeleteModelConfirm">
              Cancel
            </button>
            <button type="button" class="btn btn-danger" @click="deleteModel()" :disabled="loadingDelete">
              {{loadingDelete ? 'Processing...' : 'Delete'}}
            </button>
          </div>
        </div>
      </div>
     </div>
    <!-- endModal -->
  </wrapper>
</template>

<script>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";
import SideBar from "../SideBar";
import { Wrapper, Card } from "../Layout";
import ModalAddModel from "./Components/ModalAddModel.vue";

import Swal from "sweetalert2";

export default {
  name: "PartCompabilityDetailPage",
  components: {
    SideBar,
    Multiselect,
    Wrapper,
    Card,
    ModalAddModel,
  },
  data() {
    return {
      spaceRegex: /[\u00A0\uFEFF\u202F]/g,
      dataDetails:'',
      modelList:[],
      filteredModelList: [],
      dataPart: '',
      searchModel:'',
      loadingDelete: false,
      selectAll : false,
      selectedModels: [],
      deleteModelWarningMsg :'',
      admin: "",
      adminId: "",

      permission: [],
      viewDashboard: false,
      viewOrder: false,
      viewReturn: false,
      viewProduct: false,
      viewPartCompatiblity : false,
      addPartCompatiblity : false,
      deletePartCompatiblity : false,
      viewPairing: false,
      viewReconcile: false,
      viewResolution: false,
      viewLessor: false,
      viewLessee: false,
      viewEmployee: false,
      editOrder: false,
      editReturn: false,
      editProduct: false,
      editPairing: false,
      editReconcile: false,
      editResolution: false,
      editLessor: false,
      editLessee: false,
      editEmployee: false,
      loadingDelete : false,
    };
  },
  watch: {

    selectedModels(newValue) {
      if(newValue.length == this.filteredModelList.length && this.filteredModelList.length > 0) {
        this.selectAll = true
      } else {
        this.selectAll = false
      }
    },
    searchModel(newValue) {
      if(newValue) {
        this.selectedModels = []
        this.filteredModelList = this.modelList.filter(item => item.itemName.toLowerCase().includes(newValue.toLowerCase()))
      } else {
        this.selectedModels = []
        this.filteredModelList = this.modelList;
      }
      
    }
  },
  methods: {
    toggleSelectAll() {
      if(this.selectAll) {
        this.selectedModels = [...this.filteredModelList]
      } else {
        this.selectedModels = []
      }
      
    },
    toggleSelected(model) {
      if(!this.selectedModels.find(item => item.itemCode == model.itemCode)) {
        this.selectedModels.push(model)
      } else {
        let indexLocation = this.selectedModels.findIndex (item => item.itemCode == model.itemCode)
        this.selectedModels.splice(indexLocation, 1);
      }
    },
    openModalAddModel() {
      this.dataPart = {
        itemCode : this.$route.params.id,
        itemName : this.$route.query.itemName,
        itemGroup : this.$route.query.itemGroup
      }

      // open modal
      $("#modalAddModel").modal('show')
    },
    openConfirmDeleteModal(model){
      if(model) {
        this.selectedModels = [model]
        this.deleteModelWarningMsg = `${model.itemName}`
      } else {
        this.deleteModelWarningMsg = `${this.selectedModels.length} selected models`
      }
      
      $("#modalDeleteConfirmation").modal('show')
    },
    closeDeleteModelConfirm() {
      $("#modalDeleteConfirmation").modal('hide')
    },

    deleteModel() {
      this.loadingDelete = true;
      const swalWithBootstrapButtons = Swal.mixin({
        customClass: {
          confirmButton: "btn btn-primary ml-2",
          cancelButton: "btn btn-danger",
        },
        buttonsStyling: false,
      });
        
      this.loadingDelete = true
      let partCompatibilities = []
      this.selectedModels.forEach(item => {
        // let codes = '';
        // item.itemCodes.forEach(code => {
        //   codes = codes ? `${codes},${code}` : `${code}`
        // })
        partCompatibilities.push({
          itemCodes : item.itemCodeGroup,
          itemName : item.itemName,
          itemCode : item.itemCode,
          itemGroup : item.itemGroup,
        })
      })
      

      this.$http.post(
        process.env.EDIT_PART_COMPABILITIES,
        {
          action: "remove",
          itemCode: this.$route.params.id,
          partCompatibilities: partCompatibilities
        },
        {
          headers: {
            "Asani-Token": localStorage.getItem("jwt"),
          },
        }
      )
      .then((response) => {
          if (response.data.status !== 200) {
            swalWithBootstrapButtons.fire({
              title: "Failed",
              text:  `${response.data.message}`,
              icon: "error",
            }).then((result) => {
              this.loadingDelete = false;
              this.selectedModels = [];
              this.closeDeleteModelConfirm()
            })
          } else if (response.data.status == 200) {
            swalWithBootstrapButtons.fire({
              title: "Success",
              text: `${response.data.message}`,
              icon: "success",
            }).then(result => {
              this.loadingDelete = false
              this.selectedModels = [];
              this.selectAll = false;
              this.closeDeleteModelConfirm()
              this.getDetails()
            })
          }
          this.loadingDelete = false;
      })
      .catch((error) => {
        swalWithBootstrapButtons.fire({
          title: "Failed",
          text:  `${error.response.data.message}`,
          icon: "error",
        })
        .then((result) => {
          this.loadingDelete = false;
          if (error.response.data.status == 401) {
            this.handleLogout();
          }
        });
      });
    },
    getDetails() {
      this.loadingTable = true
      this.$http.get(
        process.env.GET_PART_COMPABILITY_DETAIL+`/${this.$route.params.id}/details`,
        {
          timeout: 500 * 1000,
          headers: {
            "Asani-Token": localStorage.getItem("jwt"),
            "Content-Type": "application/json",
          },
        }
      )
      .then((response) => {
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          });
            // this.handleLogout();
        } else {
          this.dataDetails = response.data.content
          this.modelList = response.data.content[0].parts || []
          this.filteredModelList = this.modelList
        } 
        this.loadingTable = false;
      })
      .catch((error) => {
        this.loadingTable = false;
        if (!error.response) {
          swal("Error", "Tidak ada respons dari server.", "error");
          return;
        }

        const status = error.response.data.status;
        const message = error.response.data.message || "Terjadi kesalahan";

        swal("Sorry", message, "error", {
          button: "Ok",
        }).then(() => {
          if (status === 401) {
            this.handleLogout();
          }
        });
      });
    },
    toPage(e) {
      this.$router.push(e);
    },
    async handleLogout() {
      try {
        const response = await this.$http.post(
          process.env.LOGOUT,
          {},
          {
            headers: {
              "Asani-Token": localStorage.getItem("jwt"),
            },
          }
        );
        if (response.data.status !== 200) {
          swal("Sorry", response.data.message, "error", {
            button: "Ok",
          });
          return;
        }
      } catch (error) {
        if (error.response.data.status != 401) {
          swal("Sorry", error.response.data.message, "error", {
            button: "Ok",
          });
          return;
        }
      }
      localStorage.removeItem("jwt");
      localStorage.removeItem("admin_name");
      localStorage.removeItem("roles");
      localStorage.removeItem("user_email");
      localStorage.removeItem("admin_id");
      localStorage.removeItem("changeCatalogPermission");
      this.$router.push("/");
    },
    cekLogin() {
      if (localStorage.getItem("jwt") == null) {
        this.$router.push("/");
      }
    },
    cekPermission() {
      this.permission = localStorage
        .getItem("roles")
        .replace(/"/g, "")
        .replace("[", "")
        .replace("]", "")
        .split(",");
      for (var i = 0; i < this.permission.length; i++) {
        if (this.permission[i] == "1") {
          this.viewDashboard = true;
        }
        if (this.permission[i] == "2.1") {
          this.viewOrder = true;
        }
        if (this.permission[i] == "2.2") {
          this.editOrder = true;
        }
        if (this.permission[i] == "3.1") {
          this.viewReturn = true;
        }
        if (this.permission[i] == "3.2") {
          this.editReturn = true;
        }
        if (this.permission[i] == "4.1") {
          this.viewProduct = true;
        }
        if (this.permission[i] == "4.2") {
          this.editProduct = true;
        }
        if(this.permission[i] == "4.5") {
          this.viewPartCompatiblity = true
        }
        if(this.permission[i] == "4.7") {
          this.addPartCompatiblity = true
        }
        if(this.permission[i] == "4.8") {
          this.deletePartCompatiblity = true
        }
        if (this.permission[i] == "5.1") {
          this.viewPairing = true;
        }
        if (this.permission[i] == "5.2") {
          this.editPairing = true;
        }
        if (this.permission[i] == "6") {
          this.viewReconcile = true;
        }
        if (this.permission[i] == "7.1") {
          this.viewResolution = true;
        }
        if (this.permission[i] == "7.2") {
          this.editResolution = true;
        }
        if (this.permission[i] == "8.1") {
          this.viewLessor = true;
        }
        if (this.permission[i] == "8.2") {
          this.editLessor = true;
        }
        if (this.permission[i] == "9.1") {
          this.viewLessee = true;
        }
        if (this.permission[i] == "9.2") {
          this.editLessee = true;
        }
        if (this.permission[i] == "10") {
          this.viewEmployee = true;
        }
      }
      if (this.viewPartCompatiblity == false) {
        this.$router.push("/");
      }
    },
    sidebar() {
      $("#wrapper").toggleClass("toggled");
    },
    toDetail(id) {
      this.$router.push("/product/detail/" + id);
    },
    sendLog(x, y) {
      var today = new Date();
      var month = today.getMonth() + 1;
      if (month < 10) {
        month = "0" + month;
      }
      var dateDay = today.getDate();
      if (dateDay < 10) {
        dateDay = "0" + dateDay;
      }
      var hours = today.getHours();
      if (hours < 10) {
        hours = "0" + hours;
      }
      var minutes = today.getMinutes();
      if (minutes < 10) {
        minutes = "0" + minutes;
      }
      var second = today.getSeconds();
      if (second < 10) {
        second = "0" + second;
      }
      var date = today.getFullYear() + "-" + month + "-" + dateDay;
      var time = hours + ":" + minutes + ":" + second;
      var dateTime = date + " " + time;
      var admin = this.admin;
      var command = "add-logs";
      var productName =
        this.productNameChoose == null
          ? this.productNameChoose
          : this.productNameChoose.replace(this.spaceRegex, " ");
      if (y == "34") {
        var newShowing = this.showingChoose;
        this.$http
          .post(
            process.env.LOG_URL + "/product/" + x,
            {
              codeLogs: y,
              params: [productName, newShowing],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$http
          .post(
            process.env.LOG_URL + "/product/" + x,
            {
              codeLogs: y,
              params: [productName],
            },
            {
              headers: { "Asani-Token": localStorage.getItem("jwt") },
            }
          )
          .then((response) => {})
          .catch((error) => {
            console.log(error);
          });
      }
    },
  },
  async created() {
    this.admin = localStorage.getItem("admin_name");
    this.adminId = localStorage.getItem("admin_id");
    this.cekLogin();
    this.cekPermission();
    this.getDetails()
  },
};
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.modal-content {
  border-radius: 8px;
}

.modal-header {
  border-bottom: none;
  padding-bottom: 0;
}
        
.modal-body {
  padding: 20px 30px;
  text-align: center;
}
     
.modal-title {
  font-size: 24px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
}
        
.item-name {
  font-weight: 600;
  color: #333;
}
.warning-text {
  color: #666;
  font-size: 15px;
  line-height: 1.5;
}

.warning-icon {
  width: 80px;
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
  background-color: #fff;
}
        
.modal-footer {
  border-top: none;
  justify-content: center;
}

.empty-state {
  text-align: center;
  padding: 40px 20px;
}
.empty-icon {
  width: 80px;
  height: 80px;
  background-color: #e3f2fd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 20px;
}
.empty-icon i {
  font-size: 40px;
  color: #2196F3;
}
.empty-title {
  font-family: Inter;
  font-weight: 400;
  font-style: Regular;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.1%;
  text-align: center;
  vertical-align: middle;
  color: #2E3646;
  margin-bottom: 8px;
}
.empty-subtitle {
  font-size: 12px;
  font-weight: 400;
  font-style: Regular;
  color: #6B7280;
  line-height: 18px;
  margin-bottom: 24px;
}
.btn-add-models {
  background-color: #007bff;
  border: none;
  color: white;
  padding: 10px 24px;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  transition: background-color 0.2s;
}
.btn-add-models:hover {
  background-color: #0056b3;
}
.btn-add-models i {
  font-size: 16px;
}
.item-card {
  background: white;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 20px;
  margin: 0 auto;
}
.item-label {
  color: #6c757d;
  font-size: 14px;
  margin-bottom: 5px;
}
.item-value {
  color: #212529;
  font-size: 16px;
  font-weight: 400;
}
.btn-add-models {
  background-color: #007bff;
  border: none;
  padding: 8px 20px;
  font-size: 14px;
  border-radius: 4px;
}
.btn-add-models:hover {
  background-color: #0056b3;
}

.search-delete-container {
  background-color: #fff;
  border-bottom: 1px solid #e0e0e0;
}
        
.search-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 15px;
}

.search-section {
            flex: 1;
        }
        
        .search-label {
            font-size: 13px;
            color: #666;
            margin-bottom: 5px;
            font-weight: 500;
        }
        
        .search-input-wrapper {
            position: relative;
        }
.search-input-wrapper .search-icon {
            position: absolute;
            left: 12px;
            top: 50%;
            transform: translateY(-50%);
            color: #999;
            font-size: 14px;
        }
        
        .search-input {
            width: 100%;
            padding: 8px 12px 8px 35px;
            border: 1px solid #ddd;
            border-radius: 4px;
            font-size: 14px;
            outline: none;
            transition: border-color 0.2s;
        }
        
        .search-input:focus {
            border-color: #007bff;
        }
        
        .search-input::placeholder {
            color: #999;
        }
        
        .btn-delete-selected {
            background-color: #dc3545;
            color: #fff;
            border: none;
            padding: 8px 20px;
            border-radius: 4px;
            font-size: 14px;
            font-weight: 500;
            display: flex;
            align-items: center;
            gap: 8px;
            cursor: pointer;
            white-space: nowrap;
            transition: background-color 0.2s;
        }
        
        .btn-delete-selected:hover {
            background-color: #c82333;
        }
        
        .btn-delete-selected:disabled {
            background-color: #e9ecef;
            color: #6c757d;
            cursor: not-allowed;
        }
        
        .btn-delete-selected i {
            font-size: 12px;
        }
/* old  */
.search-container {
      background: white;
      border-radius: 8px;
      padding: 20px;
      max-width: 1200px;
      margin: 0 auto;
    }
    .search-title {
      font-size: 14px;
      font-weight: 600;
      color: #2E3646;
      margin-bottom: 15px;
    }
    .search-input-wrapper {
      position: relative;
      margin-bottom: 20px;
    }
    .search-input {
      width: 100%;
      padding: 10px 40px 10px 40px;
      border: 1px solid #ced4da;
      border-radius: 6px;
      font-size: 14px;
    }
    .search-input:focus {
      outline: none;
      border-color: #80bdff;
      box-shadow: 0 0 0 0.2rem rgba(0,123,255,.25);
    }
    .search-icon {
      position: absolute;
      left: 12px;
      top: 50%;
      transform: translateY(-50%);
      color: #6c757d;
    }
    .clear-icon {
      position: relative;
      right: 1.5rem;
      top: 50%;
      transform: translateY(-50%);
      color: #6c757d;
      cursor: pointer;
      font-size: 18px;
    }
    .clear-icon:hover {
      color: #212529;
    }
/* old */
    .checkbox-custom {
      width: 18px;
      height: 18px;
      cursor: pointer;
    }
    .item-code-badge {
      display: inline-block;
      padding: 6px 12px;
      background-color: #e7f3ff;
      color: #0066cc;
      border-radius: 4px;
      font-size: 13px;
      margin-right: 8px;
      margin-bottom: 5px;
      border: 1px solid #b3d9ff;
    }
    .btn-delete {
      background-color: #fff;
      border: 1px solid #dc3545;
      color: #dc3545;
      padding: 6px 12px;
      border-radius: 4px;
      cursor: pointer;
      font-size: 14px;
    }
    .btn-delete:hover {
      background-color: #dc3545;
      color: white;
    }
    .btn-info-circle {
      background-color: #17a2b8;
      color: white;
      border: none;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      cursor: pointer;
      margin-left: 8px;
      display: inline-flex;
      align-items: center;
      justify-content: center;
    }
    .btn-info-circle:hover {
      background-color: #138496;
    }
    .total-models {
      color: #6c757d;
      font-size: 14px;
      margin-top: 15px;
    }
/* ================ */
.text-main-color {
  color: #2E3646;
}

.default-btn {
  font-weight: 600;
  height: fit-content;
  font-size: .875rem;
  padding: .5rem .75rem;
  border-radius: .375rem;
}

.icon-btn {
  border-radius: 8px;
  padding: 4px;
  background: #ffffff;
  width: 34px;
}

.icon-btn-blue {
  border: 1px solid #247FEC66;
}

.icon-btn-orange {
  border: 1px solid #F2641966;
}

.icon-btn-red {
  border: 1px solid #FF344480;
}

.icon-btn-green {
  border: 1px solid #C8DFCA;
}

.reset-btn {
  border: 1px solid #D1D9E2;
  color: #2E3646;
}

.field-label {
  width: 160px;
}

.pagination {
  padding: 0px 0;
}

.pagination ul {
  margin: 0;
  padding: 0;
  list-style-type: none;
}

.pagination a {
  display: inline-block;
  padding: 1px 6px;
  color: #222;
}

.p8 a {
  background-color: #2797fb;
  color: #fff;
  border: 1px solid #2797fb;
}

.p8 a:hover {
  text-decoration: none;
}
.p8 a.page:hover {
  text-decoration: none;
  color: #fff;
}

.p8 .is-active {
  background-color: #fff;
  color: #2797fb;
}

.total-data {
  font-size: 14px;
  color: #343a40;
}

.right-dropdown {
  margin-left: 7px;
}

.main-content-wrapper {
  padding: 1rem 4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/Catalog/PartCompabilityDetailPage.vue